import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { ArrowRight, Globe, Search, Handshake, Truck, FileCheck, TrendingUp, MapPin } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Globe: Globe,
  Search: Search,
  Handshake: Handshake,
  Truck: Truck,
  FileCheck: FileCheck,
  TrendingUp: TrendingUp,
  MapPin: MapPin,
};

export const ServicesOverview = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-teal-100 text-teal-700 text-sm font-medium mb-4">
            Our Services
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-6">
            Comprehensive Import & Export Solutions
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            From sourcing to delivery, we provide end-to-end trade services that 
            simplify international commerce and maximise your success in both directions.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group relative bg-white border-slate-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300 overflow-hidden"
              >
                {/* Hover Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-teal-50/0 to-teal-100/0 group-hover:from-teal-50/50 group-hover:to-teal-100/30 transition-all duration-500" />
                
                <CardHeader className="relative">
                  <div className="p-3 w-fit rounded-xl bg-navy-900 group-hover:bg-teal-600 transition-colors duration-300 mb-4">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <CardTitle className="text-xl text-navy-900 group-hover:text-teal-700 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-slate-600">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="relative">
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature) => (
                      <li key={feature} className="flex items-center gap-2 text-sm text-slate-600">
                        <div className="w-1.5 h-1.5 rounded-full bg-teal-500" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={`/services#${service.id}`}
                    className="inline-flex items-center text-sm font-medium text-navy-900 hover:text-teal-600 transition-colors"
                  >
                    Learn more
                    <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link to="/services">
            <Button
              size="lg"
              className="bg-navy-900 hover:bg-navy-800 text-white px-8 rounded-xl"
            >
              View All Services
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
